import type { DisciplineBalance, DisciplineBalanceReference } from './interfaces'

import { DisciplineBalanceAction, DisciplineBalanceReferenceType } from './enums'

export const BALANCE_EMPTY_CELL = '--'
export const BALANCE_LESSONS_MIN = 1
export const BALANCE_LESSONS_MAX = 200
export const BALANCE_COMMENT_MAX_LENGTH = 255
export const BALANCE_DEFAULT_REASON = 'OTHER'

const COMMENT_TOOLTIP_LENGTH = 26
const COMMENT_PREVIEW_LENGTH = 23

const REFERENCE_TITLES: Record<DisciplineBalanceReferenceType, string> = {
  [DisciplineBalanceReferenceType.Order]: 'Order',
  [DisciplineBalanceReferenceType.Subscription]: 'Subscription',
  [DisciplineBalanceReferenceType.Lesson]: 'Lesson',
}

export const formatBalanceCounter = (value: number): string => (value > 0 ? `+${value}` : String(value))

export const getBalanceReferenceTitle = (reference: DisciplineBalanceReference): string =>
  `${REFERENCE_TITLES[reference.type] ?? REFERENCE_TITLES[DisciplineBalanceReferenceType.Order]} #${reference.id}`

/** A long comment is cut to fit the column; the full text goes to the tooltip. */
export const getBalanceCommentPreview = (comment: string | null): { text: string, tooltip: string | null } => {
  const text = comment?.trim() || BALANCE_EMPTY_CELL
  if (text.length < COMMENT_TOOLTIP_LENGTH) return { text, tooltip: null }

  return { text: `${text.slice(0, COMMENT_PREVIEW_LENGTH).trim()}...`, tooltip: text }
}

export const isBalanceLessonsValid = (value: number): boolean =>
  Number.isInteger(value) && value >= BALANCE_LESSONS_MIN && value <= BALANCE_LESSONS_MAX

export const getSignedBalanceValue = (action: DisciplineBalanceAction, lessons: number): number =>
  action === DisciplineBalanceAction.Remove ? -lessons : lessons

/** The list reads a replica: a row stored a moment ago may still be missing from the first page. */
export const mergeCreatedBalance = (balances: DisciplineBalance[], created: DisciplineBalance): DisciplineBalance[] =>
  balances.some(balance => balance.id === created.id) ? balances : [created, ...balances]
